export async function postRequest(url, data) {
  let fullResponse;
  const body = await fetch(url, {
    body: JSON.stringify(data),
    credentials: 'include',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    method: 'POST',
    mode: 'cors',
  }).then((response) => {
    fullResponse = response;
    return response.json();
  }).then((b) => {
    return b;
  }).catch((err) => {
    console.error('Error in postRequest');
    console.error(err);
  });
  fullResponse = fullResponse || {};
  console.log(body);
  return {
    body: body,
    ok: fullResponse.ok,
    status: fullResponse.status,
    statusText: fullResponse.statusText,
    type: fullResponse.type,
    url: fullResponse.url
  };
};



// WEBPACK FOOTER //
// ./src/resources/utils/ajax.js